module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.gamePageModel.retrievedInformation) ? _c('section', {
    attrs: {
      "id": "game-companion-content"
    }
  }, [_c('div', {
    staticClass: "main-details"
  }, [_c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.game,
      "profile-type": "game",
      "size": "super-large",
      "show-xp-info": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "details-container"
  }, [_c('h1', {
    staticClass: "game-alias"
  }, [_c('i', {
    staticClass: "fas fa-gamepad"
  }), _vm._v("\n                " + _vm._s(_vm.game.alias) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "platform"
  }, [_c('h3', [_vm._v("Platform")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.game.platforms))])]), _vm._v(" "), _c('div', {
    staticClass: "genre"
  }, [_c('h3', [_vm._v("Genre")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.game.genres))])]), _vm._v(" "), _c('div', {
    staticClass: "rating"
  }, [_c('h3', [_vm._v("Rating")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("capitalizeFirstLetter")(_vm.game.rating)))])]), _vm._v(" "), _c('div', {
    staticClass: "dev-status"
  }, [_c('h3', [_vm._v("Dev Status")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.getDevStatus(_vm.game.devStatus)))])]), _vm._v(" "), (_vm.game.releaseDate) ? _c('div', {
    staticClass: "release-date"
  }, [_c('h3', [_vm._v("Release Date")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.game.releaseDate))])]) : _vm._e(), _vm._v(" "), (_vm.showContactOptions) ? _c('div', {
    staticClass: "connect-options"
  }, [(_vm.showRequestOption) ? _c('span', {
    on: {
      "click": _vm.sendRequestToJoin
    }
  }, [_c('i', {
    staticClass: "fas fa-user"
  }), _vm._v(" Request to Join")]) : _vm._e(), _vm._v(" "), (!_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
    on: {
      "click": _vm.updateFollowStatus
    }
  }, [_c('i', {
    staticClass: "far fa-paper-plane"
  }), _vm._v(" Follow")]) : _vm._e(), _vm._v(" "), (_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
    on: {
      "click": _vm.updateFollowStatus
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v(" Un follow")]) : _vm._e(), _vm._v(" "), (_vm.savingFollowingChange) ? _c('span', [_c('i', {
    staticClass: "fas fa-sync fa-spin"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSeeking) ? _c('div', {
    staticClass: "currently-recruiting"
  }, [(_vm.isSeeking) ? _c('div', {
    staticClass: "wants-to-collab"
  }, [_vm._v("Actively Recruiting")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Roles")]), _vm._v(" "), (_vm.game.seekingRoles) ? _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.game.seekingRoles))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "role-list"
  }, [(_vm.game.seekingProducers) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=producers'
    }
  }, [_c('span', [_vm._v("Producers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingDesigners) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=designers'
    }
  }, [_c('span', [_vm._v("Designers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingArtists) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=artists'
    }
  }, [_c('span', [_vm._v("Artists")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingProgrammers) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=programmers'
    }
  }, [_c('span', [_vm._v("Programmers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingWriters) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=writers'
    }
  }, [_c('span', [_vm._v("Writers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingMusicians) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=musicians'
    }
  }, [_c('span', [_vm._v("Musicians")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingSfxArtists) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=sfx'
    }
  }, [_c('span', [_vm._v("SFX Artists")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingTesters) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=testers'
    }
  }, [_c('span', [_vm._v("Testers")])]) : _vm._e()], 1), _vm._v(" "), (_vm.game.skills.length > 0) ? [_c('h3', [_vm._v("Skills")]), _vm._v(" "), (_vm.showSkillTags) ? _c('div', {
    staticClass: "skills"
  }, [(_vm.game.skills) ? _c('div', {
    staticClass: "skill-list"
  }, _vm._l((_vm.game.skills), function(skillId) {
    return _c('router-link', {
      staticClass: "skill-tag",
      attrs: {
        "to": '/Browse/Developers?seekingSkill=' + skillId
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.getSkill(skillId)) + "\n                            ")])
  })) : _vm._e()]) : _vm._e()] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (!_vm.editDetailsMode && !_vm.editVitalsMode && !_vm.editRecruitmentMode && !_vm.leaveGameMode) ? _c('div', {
    staticClass: "edit-options"
  }, [(_vm.isModerator) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editVitalsMode = true
      }
    }
  }, [_vm._v("Edit Title and Avatar")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editDetailsMode = true
      }
    }
  }, [_vm._v("Edit Game Details")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editRecruitmentMode = true
      }
    }
  }, [_vm._v("Edit Recruitment Details")]) : _vm._e(), _vm._v(" "), (_vm.isMember) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveGameMode = true
      }
    }
  }, [_vm._v("Leave Game Project")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editVitalsMode) ? _c('edit-game-vitals', {
    attrs: {
      "game": _vm.game
    },
    on: {
      "doneEditing": function($event) {
        _vm.editVitalsMode = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editDetailsMode) ? _c('edit-game', {
    on: {
      "doneEditing": function($event) {
        _vm.editDetailsMode = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editRecruitmentMode) ? _c('edit-game-recruitment', {
    attrs: {
      "game": _vm.game
    },
    on: {
      "doneEditing": function($event) {
        _vm.editRecruitmentMode = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.leaveGameMode) ? _c('leave-game', {
    attrs: {
      "game": _vm.game,
      "is-owner": _vm.isOwner
    },
    on: {
      "doneEditing": function($event) {
        _vm.leaveGameMode = false
      }
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90c48cf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/GameDetails.vue
// module id = 902
// module chunks = 2